import { filterNulls, getCustomerPrice } from '@web/utils/src';
import {
  ArticleData,
  CartItemData,
  QuantityOptions,
  Unit,
} from '@agrantis/cart';

export function getItemDataFromArticle(
  article: ArticleData,
  isVolumeDiscountsEnabled = false,
  hasLivePrice = false,
  retailerBasePriceAmount?: number | null,
): CartItemData {
  const locations = filterNulls(article.item.inventoryLocations || []).map(
    (l) => ({
      name: l.location?.name ?? '',
      id: parseInt(l.location?.id ?? ''),
    }),
  );

  const quantityOptions: QuantityOptions = {
    post: (article.quantityOptions?.post || []).filter((i) => i !== null),
    pickup: (article.quantityOptions?.pickup || []).filter((i) => i !== null),
    delivery: (article.quantityOptions?.delivery || []).filter(
      (i) => i !== null,
    ),
    default:
      article.quantityOptions?.default === 'pickup' ? 'pickup' : 'delivery',
  };

  const hasValidIndividualCustomerPrice =
    getCustomerPrice(article.customerPrice) !== null;

  const volumeDiscounts = isVolumeDiscountsEnabled
    ? article.volumeDiscounts ?? []
    : [];

  return {
    id: parseInt(article.item.id),
    taxRate: article.item.taxRate ?? 0,
    itemPrice: article.item.salePrice ?? 0,
    basePrice: article.item.basePrice ?? 0,
    articleId: article.id ? parseInt(article.id) : 0,
    articleName: article.name || '-',
    quantityStocked: article.item.quantityStocked ?? 0,
    deliveryTimeEst: article.item.deliveryTimeEst ?? 0,
    leadTimeEst: article.item.leadTimeEst ?? 0,
    quantityPending: article.item.quantityPending ?? 0,
    locations,
    quantity: article.amount ?? 0,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    unit: article.unit as Unit,
    quantityOptions,
    loose: article.loose || false,
    defaultLocation: locations[0]?.id,
    hasValidIndividualCustomerPrice,
    volumeDiscounts,
    hasLivePrice,
    retailerBasePriceAmount,
  };
}
